import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/contexts/AuthContext';
import Login from './auth/components/Login';
import ForgotPassword from './auth/components/ForgotPassword';
import ResetPassword from './auth/components/ResetPassword';
import Toast from './shared/components/Toast';
import Navbar from './shared/components/Navbar';
import Dashboard from './features/dashboard/components/Dashboard';
import WoltPage from './features/wolt/components/WoltPage';
import FoodoraUploadPage from './features/cash/components/FoodoraUploadPage';
import VouchersUploadedPage from './features/cash/components/VouchersUploadedPage';
import Settings from './features/settings/components/Settings';
import MembersPage from './features/members/components/MembersPage';

const AppContent = () => {
  const { isAdmin } = useAuth();

  return (
    <div className="flex min-h-screen">
      <Navbar />
      <div className="flex-1 min-w-0">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/wolt" element={<WoltPage />} />
          <Route path="/foodora-upload" element={<FoodoraUploadPage />} />
          <Route path="/vouchers-uploaded" element={<VouchersUploadedPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/members" element={isAdmin ? <MembersPage /> : <Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toast />
      </div>
    </div>
  );
};

const AuthWrapper = () => {
  const { user, loading, passwordFlow } = useAuth();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-gray-300 border-t-black rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (passwordFlow) {
    return (
      <>
        <ResetPassword />
        <Toast />
      </>
    );
  }

  if (!user) {
    return (
      <>
        {showForgotPassword ? (
          <ForgotPassword onBackToLogin={() => setShowForgotPassword(false)} />
        ) : (
          <Login onForgotPassword={() => setShowForgotPassword(true)} />
        )}
        <Toast />
      </>
    );
  }

  return <AppContent />;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AuthWrapper />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
